import { round } from './number';

export const preventDefault = (e: { preventDefault: () => void }) => {
  e.preventDefault();
};

export const stopPropagation = (e: { stopPropagation: () => void }) => {
  e.stopPropagation();
};

export const budgetPercentageCal = (remainingBudgetAmount: number, budgetAmount: number) =>
  Number(budgetAmount) === 0
    ? 0
    : round((Number(remainingBudgetAmount) / Number(budgetAmount)) * 100, 2) > 100
    ? 100
    : round((Number(remainingBudgetAmount) / Number(budgetAmount)) * 100, 2);

export const getBackgroundColor = (value: string) => {
  if (Number(value) < 0) {
    return { backgroundColor: '#94c94747' };
  }
  return {};
};

export function calculatePercentage(total: number, value: number) {
  let percentage = (value / total) * 100;
  return round(percentage, 2);
}

export const isFirefoxBrowser = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

export const isNullOrUndefined = (value: any) => value === null || value === undefined;

export const isTrue = (value: any) => value === true;
export const isFalse = (value: any) => value === false;
